import React, { useState, useEffect } from 'react';
import { database } from '../firebase';
import { ref, onValue } from 'firebase/database';
import SafePlyr from './SafePlyr';
import '../styles/global.css';
import LoadingSpinner from './LoadingSpinner';

const Tutorials = () => {
    const [videos, setVideos] = useState([]);
    const [categories, setCategories] = useState(['Todos']);
    const [selectedCategory, setSelectedCategory] = useState('Todos');
    const [loading, setLoading] = useState(true);
    const [selectedVideo, setSelectedVideo] = useState(null);

    useEffect(() => {
        const videosRef = ref(database, 'config/youtube');
        const unsub = onValue(videosRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const videoList = Object.entries(data).map(([id, val]) => {
                    if (typeof val === 'string') {
                        return {
                            id,
                            videoId: val,
                            title: `Tutorial ${id}`,
                            description: 'Video tutorial de la aplicación',
                            thumbnailUrl: `https://img.youtube.com/vi/${val}/mqdefault.jpg`,
                            category: 'Aplicación',
                            videoUrl: '',
                            source: 'youtube'
                        };
                    }
                    const source = val.source || (val.videoUrl ? 'r2' : 'youtube');
                    const defaultThumb = source === 'tiktok'
                        ? 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=400&q=80'
                        : (source === 'youtube' && val.videoId ? `https://img.youtube.com/vi/${val.videoId}/mqdefault.jpg` : 'https://images.unsplash.com/photo-1507682531662-421b17ac4f83?auto=format&fit=crop&w=400&q=80');
                    return {
                        id,
                        ...val,
                        source,
                        thumbnailUrl: val.thumbnailUrl || defaultThumb
                    };
                });

                setVideos(videoList);

                const cats = ['Todos', ...new Set(videoList.map(v => v.category).filter(Boolean))];
                setCategories(cats);
            }
            setLoading(false);
        });
        return () => unsub();
    }, []);

    const filteredVideos = videos.filter(v =>
        selectedCategory === 'Todos' || v.category === selectedCategory
    );

    const currentIndex = filteredVideos.findIndex(v => v.id === selectedVideo?.id);
    const hasPrev = currentIndex > 0;
    const hasNext = currentIndex < filteredVideos.length - 1;
    const goToPrev = () => { if (hasPrev) setSelectedVideo(filteredVideos[currentIndex - 1]); };
    const goToNext = () => { if (hasNext) setSelectedVideo(filteredVideos[currentIndex + 1]); };

     

    if (loading) return   <LoadingSpinner label="Cargando datos..." height="300px" />;

    return (
        <div className="tutorials-container" style={{ padding: '20px', color: 'var(--text-primary)' }}>
            {/* Inject dynamic styles for hover micro-animations and custom styling */}
            <style>{`
                .video-card {
                    background: var(--bg-secondary);
                    border-radius: 12px;
                    overflow: hidden;
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
                    cursor: pointer;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    display: flex;
                    flex-direction: column;
                }
                .video-card:hover {
                    transform: translateY(-5px);
                    border-color: var(--accent);
                    box-shadow: 0 12px 20px rgba(0, 229, 255, 0.15);
                }
                .video-card img {
                    transition: transform 0.5s ease;
                }
                .video-card:hover img {
                    transform: scale(1.05);
                }
                .category-chip {
                    padding: 8px 20px;
                    background: var(--bg-secondary);
                    color: white;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 50px;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: all 0.2s ease;
                }
                .category-chip:hover {
                    background: rgba(255, 255, 255, 0.1);
                    border-color: var(--accent);
                }
                .category-chip.active {
                    background: var(--accent);
                    color: #0a192f;
                    font-weight: bold;
                    border-color: var(--accent);
                }
                .modal-backdrop {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.92);
                    z-index: 2000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    backdrop-filter: blur(8px);
                }
                .modal-content {
                    width: 100%;
                    max-width: 1000px;
                    background: var(--bg-primary);
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                }
                .video-container-nav {
                    position: relative;
                    width: 100%;
                }
                .back-overlay-btn {
                    position: absolute;
                    top: 12px; left: 12px;
                    background: rgba(0,0,0,0.6);
                    color: white;
                    border: none;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    font-size: 1.3rem;
                    transition: all 0.2s;
                    z-index: 10;
                }
                .back-overlay-btn:hover {
                    background: rgba(0,0,0,0.85);
                    transform: scale(1.1);
                }
                .nav-arrow {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    background: rgba(0,0,0,0.5);
                    color: white;
                    border: none;
                    border-radius: 50%;
                    width: 44px;
                    height: 44px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    font-size: 1.4rem;
                    z-index: 10;
                    transition: all 0.2s;
                }
                .nav-arrow:hover {
                    background: rgba(0,0,0,0.8);
                    transform: translateY(-50%) scale(1.1);
                }
                .nav-arrow.disabled {
                    opacity: 0.2;
                    cursor: default;
                }
                .nav-arrow.prev { left: 12px; }
                .nav-arrow.next { right: 12px; }
                .video-container-tiktok {
                    position: relative;
                    height: 75vh;
                    width: 100%;
                    background: #000;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .video-container-tiktok iframe {
                    height: 100%;
                    width: 100%;
                    max-width: 420px;
                    border: none;
                }
                .video-container-standard {
                    position: relative;
                    aspect-ratio: 16/9;
                    width: 100%;
                    background: #000;
                }
                .modal-details {
                    padding: 20px;
                }
                @media (max-width: 640px) {
                    .modal-backdrop {
                        padding: 0;
                    }
                    .modal-content {
                        height: 100vh;
                        border-radius: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }
                    .video-container-tiktok {
                        height: 60vh;
                    }
                    .video-container-tiktok iframe {
                        max-width: 100%;
                    }
                    .modal-details {
                        padding: 16px;
                        flex: 1;
                        overflow-y: auto;
                    }
                    .video-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                        gap: 10px !important;
                    }
                    .video-card {
                        border-radius: 8px !important;
                    }
                    .video-card > div:first-child {
                        border-radius: 8px 8px 0 0 !important;
                    }
                    .video-card h3 {
                        font-size: 0.85rem !important;
                        margin-bottom: 4px !important;
                    }
                    .video-card div:last-child {
                        padding: 10px !important;
                    }
                    .video-card p {
                        font-size: 0.7rem !important;
                    }
                    .video-card div[style*="font-size: 0.7rem"] {
                        font-size: 0.6rem !important;
                    }
                    .tutorials-title {
                        font-size: 1.3rem !important;
                    }
                    .nav-arrow {
                        font-size: 1.2rem !important;
                        width: 36px !important;
                        height: 36px !important;
                    }
                    .back-overlay-btn {
                        font-size: 1rem !important;
                        width: 32px !important;
                        height: 32px !important;
                        top: 6px !important;
                        left: 6px !important;
                    }
                }
            `}</style>

            <h1 style={{ color: 'var(--accent)', marginBottom: '10px' }}>Video Tutoriales</h1>
            <p style={{ opacity: 0.7, marginBottom: '20px' }}>Aprende a sacar el máximo provecho de Vortex EXANI-II.</p>

            {/* CATEGORY CHIPS */}
            <div className="category-chips" style={{ display: 'flex', gap: '10px', overflowX: 'auto', marginBottom: '25px', paddingBottom: '10px' }}>
                {categories.map(cat => (
                    <button
                        key={cat}
                        onClick={() => setSelectedCategory(cat)}
                        className={`category-chip ${selectedCategory === cat ? 'active' : ''}`}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            {/* VIDEO GRID */}
            <div className="video-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                {filteredVideos.length === 0 ? (
                    <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px', background: 'var(--bg-secondary)', borderRadius: '12px' }}>
                        <p>No hay tutoriales en esta categoría por ahora.</p>
                    </div>
                ) : (
                    filteredVideos.map(video => (
                        <div
                            key={video.id}
                            className="video-card"
                            onClick={() => setSelectedVideo(video)}
                        >
                            <div style={{ position: 'relative', width: '100%', aspectRatio: '16/9', overflow: 'hidden' }}>
                                <img
                                    src={video.thumbnailUrl}
                                    alt={video.title}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                                {video.duration && (
                                    <span style={{
                                        position: 'absolute',
                                        bottom: '10px',
                                        right: '10px',
                                        background: 'rgba(0, 0, 0, 0.75)',
                                        color: 'white',
                                        padding: '2px 6px',
                                        borderRadius: '4px',
                                        fontSize: '0.75rem',
                                        fontWeight: 'bold',
                                        zIndex: 5
                                    }}>
                                        {video.duration}
                                    </span>
                                )}
                            </div>
                            <div style={{ padding: '15px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                <div style={{ fontSize: '0.7rem', color: 'var(--accent)', fontWeight: 'bold', marginBottom: '5px' }}>
                                    {video.category?.toUpperCase()}
                                </div>
                                <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', color: 'var(--text-primary)' }}>{video.title}</h3>
                                <p style={{ fontSize: '0.85rem', opacity: 0.6, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', margin: 0, marginTop: 'auto' }}>
                                    {video.description}
                                </p>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* VIDEO MODAL */}
            {selectedVideo && (
                <div
                    className="modal-backdrop"
                    onClick={() => setSelectedVideo(null)}
                >
                    <div
                        className="modal-content"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="video-container-nav">
                            <button className="back-overlay-btn" onClick={() => setSelectedVideo(null)} title="Cerrar">✕</button>
                            <button
                                className={`nav-arrow prev ${!hasPrev ? 'disabled' : ''}`}
                                onClick={hasPrev ? goToPrev : undefined}
                                title="Anterior"
                                style={!hasPrev ? { pointerEvents: 'none' } : {}}
                            >‹</button>
                            <button
                                className={`nav-arrow next ${!hasNext ? 'disabled' : ''}`}
                                onClick={hasNext ? goToNext : undefined}
                                title="Siguiente"
                                style={!hasNext ? { pointerEvents: 'none' } : {}}
                            >›</button>
                            {selectedVideo.source === 'tiktok' ? (
                                <div className="video-container-tiktok">
                                    <iframe
                                        src={`https://www.tiktok.com/embed/v2/${selectedVideo.videoId}`}
                                        title={selectedVideo.title}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            ) : (selectedVideo.source === 'youtube' || (!selectedVideo.source && selectedVideo.videoId)) ? (
                                <div className="video-container-standard">
                                    <iframe
                                        src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1&enablejsapi=1&playsinline=1`}
                                        title={selectedVideo.title}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                                        allowFullScreen
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            border: 'none'
                                        }}
                                    ></iframe>
                                </div>
                            ) : selectedVideo.videoUrl ? (
                                <div className="video-container-standard">
                                    <SafePlyr
                                        source={{
                                            type: 'video',
                                            sources: [
                                                {
                                                    src: selectedVideo.videoUrl,
                                                    type: (() => {
                                                        const url = selectedVideo.videoUrl || '';
                                                        const ext = url.split('.').pop().toLowerCase().split('?')[0];
                                                        const mimeMap = {
                                                            'mp4': 'video/mp4',
                                                            'webm': 'video/webm',
                                                            'ogg': 'video/ogg',
                                                            'mov': 'video/quicktime',
                                                            'avi': 'video/x-msvideo',
                                                            'mkv': 'video/x-matroska',
                                                            'm3u8': 'application/x-mpegURL',
                                                            'ts': 'video/MP2T',
                                                        };
                                                        return mimeMap[ext] || 'video/mp4';
                                                    })(),
                                                },
                                            ],
                                        }}
                                        options={{
                                            autoplay: true,
                                            controls: [
                                                'play-large', 'restart', 'play', 'progress', 
                                                'current-time', 'duration', 'mute', 'volume', 
                                                'captions', 'settings', 'pip', 'airplay', 'fullscreen'
                                            ],
                                            ratio: '16:9'
                                        }}
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div className="modal-details">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '15px' }}>
                                <div>
                                    <span style={{ fontSize: '0.75rem', color: 'var(--accent)', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                        {selectedVideo.category}
                                    </span>
                                    <h2 style={{ margin: '5px 0 10px 0', fontSize: '1.6rem', color: 'var(--text-primary)' }}>{selectedVideo.title}</h2>
                                    <p style={{ opacity: 0.7, margin: 0, fontSize: '0.95rem', lineHeight: '1.5' }}>{selectedVideo.description}</p>
                                </div>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
                                    <span style={{ fontSize: '0.8rem', opacity: 0.6, whiteSpace: 'nowrap' }}>
                                        {filteredVideos.length > 0 ? `${currentIndex + 1} / ${filteredVideos.length}` : ''}
                                    </span>
                                    <button
                                        onClick={hasPrev ? goToPrev : undefined}
                                        style={{
                                            padding: '8px 16px',
                                            background: hasPrev ? 'var(--bg-secondary)' : 'transparent',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            border: hasPrev ? '1px solid rgba(255,255,255,0.15)' : 'none',
                                            borderRadius: '50px',
                                            cursor: hasPrev ? 'pointer' : 'default',
                                            transition: 'all 0.2s',
                                            opacity: hasPrev ? 1 : 0.3,
                                            whiteSpace: 'nowrap'
                                        }}
                                        onMouseEnter={(e) => { if (hasPrev) { e.target.style.background = 'var(--accent)'; e.target.style.color = '#0a192f'; } }}
                                        onMouseLeave={(e) => { if (hasPrev) { e.target.style.background = 'var(--bg-secondary)'; e.target.style.color = 'white'; } }}
                                    >← Anterior</button>
                                    <button
                                        onClick={hasNext ? goToNext : undefined}
                                        style={{
                                            padding: '8px 16px',
                                            background: hasNext ? 'var(--bg-secondary)' : 'transparent',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            border: hasNext ? '1px solid rgba(255,255,255,0.15)' : 'none',
                                            borderRadius: '50px',
                                            cursor: hasNext ? 'pointer' : 'default',
                                            transition: 'all 0.2s',
                                            opacity: hasNext ? 1 : 0.3,
                                            whiteSpace: 'nowrap'
                                        }}
                                        onMouseEnter={(e) => { if (hasNext) { e.target.style.background = 'var(--accent)'; e.target.style.color = '#0a192f'; } }}
                                        onMouseLeave={(e) => { if (hasNext) { e.target.style.background = 'var(--bg-secondary)'; e.target.style.color = 'white'; } }}
                                    >Siguiente →</button>
                                    <button
                                        onClick={() => setSelectedVideo(null)}
                                        style={{
                                            padding: '8px 20px',
                                            background: 'var(--accent)',
                                            color: '#0a192f',
                                            fontWeight: 'bold',
                                            border: 'none',
                                            borderRadius: '50px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s',
                                            boxShadow: '0 4px 12px rgba(0, 229, 255, 0.3)',
                                            whiteSpace: 'nowrap'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 16px rgba(0, 229, 255, 0.5)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = '0 4px 12px rgba(0, 229, 255, 0.3)';
                                        }}
                                    >Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Tutorials;
